import {
  type NodePropertyName,
  presetFunctions,
  type PresetMeasureFunctions,
  type ViewConfigKpiMeasure,
} from '@salescore/core'
import { Form, Select } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'
import { useSetRecoilState } from 'recoil'

import { kpiFormModifiedAtom } from '../../../../recoil/view/atoms'
import { usePropertiesForCurrentMeasure } from '../../../../recoil/view/hooks/kpiForm'
import { useCurrentSheet } from '../../../../recoil/view/selectors/kpiFormSelector'
import { KpiFormMeasureCustomSqlEditor } from './KpiFormMeasureCustomSqlEditor'
import { PropertySelect } from './PropertySelect'

// countUniqueはCOUNT(DISTINCT id)をする関数だが、
// KPIの集計の文脈だと、countと結果が同じになるので、これを表示しない
export const kpiIgnoreMeasureFunctions = new Set<PresetMeasureFunctions>(['countUnique'])

export const KpiFormMeasureFormItem = ({
  measure,
  setMeasure,
  setMeasureProperty,
}: {
  measure: Partial<ViewConfigKpiMeasure> | undefined
  setMeasure: (measure: Partial<ViewConfigKpiMeasure>) => void
  setMeasureProperty: (property: NodePropertyName | undefined) => void
}): ReactElement => {
  const setFormModified = useSetRecoilState(kpiFormModifiedAtom)
  const currentSheet = useCurrentSheet()
  const properties = usePropertiesForCurrentMeasure()

  return (
    <div>
      <Form.Item label={t(`集計方法`)} rules={[{ required: true }]} required={true}>
        <Select
          value={measure?.type === 'kpiPreset' ? measure.function : ('custom' as const)}
          onChange={(value) => {
            const { tree } = currentSheet
            if (value === 'custom') {
              setMeasure({
                type: 'kpiCustom',
                sql: undefined,
                dependentNodeNames: [],
              })
            } else {
              // XXX: 「カウント系を選んだらIDを指定する」というドメインロジックがUI側に実装されていて微妙
              const property =
                (value === 'count' || value === 'countUnique') && tree !== undefined
                  ? {
                      nodeName: tree.name,
                      modelName: tree.modelName,
                      propertyName: 'id', // XXX: ロジック上ではどうせ使われない想定。であればpropertyNameはoptionalにすべきだったか？
                    }
                  : undefined
              setMeasure({
                ...measure,
                type: 'kpiPreset',
                function: value,
                property,
              })
            }
          }}
          options={[
            ...presetFunctions().filter((x) => !kpiIgnoreMeasureFunctions.has(x.value)),
            { value: 'custom', label: t('カスタム') },
          ]}
        />
      </Form.Item>
      {measure?.type === 'kpiPreset' &&
        !((measure.function === 'count' || measure.function === 'countUnique') && measure.property !== undefined) && (
          <Form.Item label={t(`集計項目`)} rules={[{ required: true }]} required={true}>
            <PropertySelect properties={properties} value={measure.property} onChange={setMeasureProperty} />
          </Form.Item>
        )}

      {measure?.type === 'kpiCustom' && <KpiFormMeasureCustomSqlEditor setFormModified={setFormModified} />}
    </div>
  )
}
